import { render, staticRenderFns } from "./SdkNotice.vue?vue&type=template&id=9b18ee82&scoped=true"
import script from "./SdkNotice.vue?vue&type=script&lang=js"
export * from "./SdkNotice.vue?vue&type=script&lang=js"
import style0 from "./SdkNotice.vue?vue&type=style&index=0&id=9b18ee82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b18ee82",
  null
  
)

export default component.exports